import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import ImageBlock from "../components/ImageBlock";
import { Reveal } from "../components/Reveal";
import { BASE_KEYWORDS, breadcrumbSchema, PAGE_KEYWORDS } from "../data/brand";
import { MEDIA } from "../data/media";

// Announced openings shown as simple type lines — location cards return here
// once addresses, phones and hours are confirmed.
const OPENINGS = [
  { region: "Dallas–Fort Worth area, Texas" },
  { region: "North Florida" },
];

export default function Locations() {
  return (
    <div className="pt-28 md:pt-36" data-testid="locations-page">
      <Seo
        title="Locations — Opening Soon in DFW & North Florida"
        description="Find your Barverse — opening soon in the DFW area and North Florida, inside Tacoverse. Address, hours and phone announced at each opening."
        path="/locations"
        jsonLd={breadcrumbSchema("/locations", "Locations")}
        keywords={`${BASE_KEYWORDS}, ${PAGE_KEYWORDS.locations}`}
      />

      <header className="container-x">
        <Reveal>
          <p className="eyebrow">Locations</p>
          <h1 className="mt-5 font-display text-6xl uppercase leading-[0.9] text-bv-ink sm:text-7xl lg:text-8xl">
            Find your Barverse.
          </h1>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-bv-sub">
            Every Barverse lives inside a Tacoverse — one entrance, two experiences. Opening soon
            in the DFW area and North Florida, with addresses, phones and bar hours announced at
            opening.
          </p>
        </Reveal>

        <Reveal delay={0.08} className="mt-12">
          <ImageBlock
            src={MEDIA.exterior.src}
            alt={MEDIA.exterior.alt}
            className="aspect-[16/9] w-full md:aspect-[21/9]"
          />
        </Reveal>
      </header>

      <section className="container-x mt-16 pb-24" aria-label="Announced openings" data-testid="opening-soon-list">
        <Reveal>
          <ul className="divide-y divide-bv-line/70 border-y border-bv-line/70">
            {OPENINGS.map((o) => (
              <li key={o.region} className="flex flex-wrap items-center justify-between gap-4 py-7">
                <span className="font-display text-3xl uppercase text-bv-ink md:text-5xl">{o.region}</span>
                <span className="chip !border-bv-flame/60 !text-bv-flame">Opening Soon</span>
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal className="mt-12">
          <p className="text-sm leading-relaxed text-bv-sub">
            Not every Tacoverse restaurant contains a Barverse — this list only includes locations
            with a full Barverse bar. Looking for food only?{" "}
            <a
              href="https://tacoverse.com"
              className="text-[#B45309] transition-colors hover:text-bv-ink"
              data-testid="locations-tacoverse-link"
            >
              Visit tacoverse.com
            </a>
            .
          </p>
        </Reveal>
      </section>
    </div>
  );
}
